"use client";

import {
  useSettingFEEnableLISPServerRenderedBrandSearch,
  useAssignSettingFEEnableLISPServerRenderedBrandSearch,
} from "@faire/deprecated-retailer-visitor-shared/settings/useSettingFEEnableLISPServerRenderedBrandSearch";
import { UserPerceivedLoadTimingContext } from "@faire/web/common/performance/userPerceivedLoadTiming/UserPerceivedLoadTimingContext";
import React, { use, useContext, useEffect } from "react";

export const DeferNonPrimaryContentWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  useNonPrimaryContentDeferRender();
  return <>{children}</>;
};

// Defer rendering until critical components are loaded
const useNonPrimaryContentDeferRender = () => {
  const { renderNonPrimaryContentPromise } = useContext(
    UserPerceivedLoadTimingContext
  );
  // use will wait for the promise to resolve before rendering the component
  // and render suspense fallback if the promise is not resolved yet
  use(renderNonPrimaryContentPromise);
};

export const MaybeDeferNonPrimaryContentWrapper = ({
  shouldDefer,
  children,
}: {
  shouldDefer: boolean;
  children: React.ReactNode;
}) => {
  const assignSettingFEEnableLISPServerRenderedBrandSearch =
    useAssignSettingFEEnableLISPServerRenderedBrandSearch();

  useEffect(() => {
    if (shouldDefer) {
      assignSettingFEEnableLISPServerRenderedBrandSearch();
    }
  }, [assignSettingFEEnableLISPServerRenderedBrandSearch, shouldDefer]);

  const shouldNotDeferRenderingTopComponents =
    useSettingFEEnableLISPServerRenderedBrandSearch();

  return shouldDefer && !shouldNotDeferRenderingTopComponents ? (
    <DeferNonPrimaryContentWrapper>{children}</DeferNonPrimaryContentWrapper>
  ) : (
    <>{children}</>
  );
};
